<template>
    <v-card>
        <v-card-title class="font-italic grey--text darken-3 text-uppercase">{{ $t('commercialPolicy') }}</v-card-title>
        <v-card-text>
            <v-row dense v-if="orderData.commercialPolicies.amount">
                <v-col cols="4" md="3">
                    <strong>{{ $t('purchaseAmount') }}</strong>
                </v-col>
                <v-col cols="8" md="9">
                    <v-row dense>
                        <v-col cols="12" md="4" class="py-0">
                            {{ $t('discount').toLowerCase() }}: {{ orderData.commercialPolicies.amount.discount }}%
                        </v-col>
                        <v-col cols="12" md="4" class="py-0">
                            {{ $t('minSum').toLowerCase() }}: {{ orderData.commercialPolicies.amount.minAmount }}
                        </v-col>
                        <v-col cols="12" md="4" class="py-0">
                            {{ $t('minSum').toLowerCase() }}: {{ orderData.commercialPolicies.amount.maxAmount }}
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-divider v-if="orderData.commercialPolicies.amount"></v-divider>
            <v-row dense v-if="orderData.commercialPolicies.date">
                <v-col cols="4" md="3">
                    <strong>{{ $t('date') }}</strong>
                </v-col>
                <v-col cols="8" md="9">
                    <v-row dense>
                        <v-col cols="12" md="4" class="py-0">
                            {{ $t('discount').toLowerCase() }}: {{ orderData.commercialPolicies.date.discount }}%
                        </v-col>
                        <v-col cols="12" md="4" class="py-0">
                            {{ $t('dateFrom').toLowerCase() }}: {{ orderData.commercialPolicies.date.minDate }}
                        </v-col>
                        <v-col cols="12" md="4" class="py-0">
                            {{ $t('dateTo').toLowerCase() }}: {{ orderData.commercialPolicies.date.maxDate }}
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-divider v-if="orderData.commercialPolicies.date"></v-divider>
            <v-row dense v-if="orderData.commercialPolicies.credit">
                <v-col cols="4" md="3">
                    <strong>{{ $t('credit') }}</strong>
                </v-col>
                <v-col cols="8" md="9">
                    <v-row dense>
                        <v-col cols="12" md="4" class="py-0">
                            {{ $t('balancePart').toLowerCase() }}: {{ orderData.commercialPolicies.credit.prepayment }}%
                        </v-col>
                        <v-col cols="12" md="4" class="py-0">
                            {{ $t('numberOfDays').toLowerCase() }}: {{ orderData.commercialPolicies.credit.term }}
                        </v-col>
                        <v-col cols="12" md="4" class="hidden-sm-and-down"></v-col>
                        <v-col cols="12" md="4" class="py-0">
                            {{ $t('creditPart').toLowerCase() }}: {{ orderData.commercialPolicies.credit.rest }}
                        </v-col>
                        <v-col cols="12" md="4" class="py-0">
                            {{ $t('date').toLowerCase() }}: {{ orderData.commercialPolicies.credit.paymentTo }}
                        </v-col>
                        <v-col cols="12" md="4" class="hidden-sm-and-down"></v-col>
                        <v-col cols="12" md="4" class="py-0">
                            {{ $t('discount').toLowerCase() }}: {{ orderData.commercialPolicies.credit.discount }}%
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-divider v-if="orderData.commercialPolicies.credit"></v-divider>
            <v-row dense v-if="orderData.commercialPolicies.prepayment">
                <v-col cols="4" md="3">
                    <strong>{{ $t('Prepayment') }}</strong>
                </v-col>
                <v-col cols="8" md="9">
                    {{ $t('discount').toLowerCase() }}: {{ orderData.commercialPolicies.prepayment.discount }}%
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import OrderExtendInfo from "../../../mixins/OrderExtendInfo"

export default {
    name: "ExtendCommercialPolicyInfo",
    mixins: [OrderExtendInfo],
}
</script>
